import React from 'react';
import { Link } from 'react-router-dom';
import { PopupLink } from './PopupLink';
const SHOP_URL = 'https://constantperil.square.site';
export function SiteNavLinks() {
  return <nav className="flex flex-col items-start text-left" data-id="element-175" data-mp="3djo5j9372dt9">
      <Link to="/music" className="lowercase hover:opacity-60" data-id="element-176" data-mp="3dk7iebdzmc0f">
        catalog
      </Link>
      <Link to="/tour" className="lowercase hover:opacity-60" data-id="element-177" data-mp="3ii93t2yvynf2">
        tour
      </Link>
      <PopupLink href={SHOP_URL} label="shop" windowName="lennon-cripe-shop" ariaLabel="Open the shop" data-id="element-178" data-mp="2lttbx08b01ys" />
      <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-179" data-mp="2pvwojs6plcln">
        guestbook
      </Link>
    </nav>;
}